const messages = {
  en: {
    richiediInfo: 'Request information',
    scorri: 'Scroll',

    contactsForm: {
      labelName: 'Name',
      labelSurname: 'Surname',
      labelEmail: 'Email',
      labelCompany: 'Company',
      labelTelephone: 'Telephone',
      labelCity: 'City',
      labelMessage: 'Message',
      labelNewsletter: 'I consent to the processing of my personal data for promotional and commercial communications.',
      labelAllowed: 'I authorize to use and process my personal data as the <a href="/privacy-policy/" target="_blank">privacy policy</a> and to receive via email or phone the information requested through this form.',
      labelEndCheck: 'Only requests from companies and not from individuals will be considered.',
      labelRimozione: 'Diamant Compositi S.r.l. will use the personal data only to perform the requested services and will not transfer them to third parties for advertising purposes. You can request the removal of your data from our systems at any time by writing to <a href="mailto:info@diamantcompositi.com">info@diamantcompositi.com</a>.',
      labelSubmit: 'Send request'
    },

    userEmail: {
      emailMetaTitle: 'Confirmation request - Diamant Compositi S.r.l.',
      emailHiddenPreHeader: 'Confirmation request - Diamant Compositi S.r.l.',
      emailTitle: 'Thank you<br> for your request.',
      emailBody: 'We will contact you as soon as possible.',
      emailSubject: 'Confirmation request - Diamant Compositi S.r.l.',

      formSuccess: 'Form successfully sent!<br> Thanks for contacting us.',
      formFailure: 'There was a problem sending the form.',
      labelTryAgain: 'Try again',
      labelContattaci: 'or contact us at <a href="mailto:info@diamantcompositi.com">info@diamantcompositi.com</a>.'
    },

    techDetails: 'Technical details',
    gallery: 'Gallery',
    scopriServizi: 'Discover the services',
    testoCompanyFooter: 'Diamant Compositi S.r.l. - P.IVA 03641800234',
    testoFooter: 'Headquarters: Via Calabria, 32/34 - 53036 Poggibonsi (SI) - Telephone: <a href="tel:+390558071675">055-8071675</a> <br>Registered office: Viale del Lavoro, 8 37060 Sorgà (VR) - Telephone: <a href="tel:+390456655044">045 665 5044</a>',
    testoFooter2nd: 'Registered office: Via Marco Biagi, CM - 37060 Sorgà (VR)  - p.iva 03641800234',
    testoFooterPP: 'General conditions',
    titoloBottomCta: 'Find out how much it pays to rely on us',
    testoBottomCta: 'Thanks to the large group we are part of,<br> we can offer you high-quality<br> carbon artifacts at a competitive price.',
    testoLinkBottomCta: 'Request Information',
    overlayBack: 'Close',
    ctaPrevious: 'Previous',
    ctaNext: 'Next',
    vociMenu: {
      'lavorazioni': 'Processes',
      'settori': 'Sectors',
      'servizi': 'Services',
      'azienda': 'Company',
      'contatti': 'Contacts'
    },

    openOnGoogle: 'Open on google maps',

    pageNotFound: {
      'title': 'Page not found',
      'content': 'The page you are looking for is not available on this site.'
    }

  },
  it: {
    richiediInfo: 'Richiedi informazioni',
    scorri: 'Scorri',

    contactsForm: {
      labelName: 'Nome',
      labelSurname: 'Cognome',
      labelEmail: 'Email',
      labelCompany: 'Azienda',
      labelTelephone: 'Telefono',
      labelCity: 'Città',
      labelMessage: 'Messaggio',
      labelEndCheck: 'Ai sensi e per gli effetti degli artt. 7, 12, 13 ss. del Reg. UE 2016/679 - GDPR:',
      labelAllowed: 'dichiaro di aver preso visione della <a href="/it/privacy-policy/" target="_blank">privacy policy</a>',
      labelAllowed2: 'per il trattamento dei miei dati personali;',
      labelNewsletter: 'acconsento al trattamento dei miei dati personali per ricevere comunicazioni promozionali / commerciali.',
      labelSubmit: 'Invia la richiesta'
    },

    userEmail: {
      emailMetaTitle: 'Conferma richiesta - Diamant Compositi S.r.l.',
      emailHiddenPreHeader: 'Conferma richiesta - Diamant Compositi S.r.l.',
      emailTitle: 'La ringraziamo<br/> per la sua richiesta.',
      emailBody: 'La contatteremo al più presto.',
      emailSubject: 'Conferma richiesta - Diamant Compositi S.r.l.',

      formSuccess: 'Form inviata con successo!<br> Grazie per averci contattato.',
      formFailure: 'Si è verificato un problema durante l\'invio della form.',
      labelTryAgain: 'Riprova',
      labelContattaci: 'o contattaci presso <a href="mailto:info@diamantcompositi.com">info@diamantcompositi.com</a>.'
    },

    techDetails: 'Dati tecnici',
    gallery: 'Gallery',
    scopriServizi: 'Scopri i servizi',
    testoCompanyFooter: 'Diamant Compositi S.r.l. - P.IVA 03641800234',
    testoFooter: 'Sede Operativa: Via Calabria, 32/34 - 53036 Poggibonsi (SI) - Telefono: <a href="tel:+390558071675">055-8071675</a> <br>Sede legale: Viale del Lavoro, 8 37060 Sorgà (VR) - Telefono: <a href="tel:+390456655044">045 665 5044</a>',
    testoFooter2nd: 'Sede legale: Via Marco Biagi, CM - 37060 Sorgà (VR)  - p.iva 03641800234',
    testoFooterPP: 'Condizioni Generali',
    titoloBottomCta: 'Scopri quanto conviene affidarsi a noi',
    testoBottomCta: 'Grazie al grande gruppo di cui<br> facciamo parte, possiamo offrirti<br> manufatti in carbonio di elevata<br> qualità a un prezzo competitivo.',
    testoLinkBottomCta: 'Richiedi informazioni',
    overlayBack: 'Chiudi',
    ctaPrevious: 'Precedente',
    ctaNext: 'Successiva',
    vociMenu: {
      'lavorazioni': 'Lavorazioni',
      'settori': 'Settori',
      'servizi': 'Servizi',
      'azienda': 'Azienda',
      'contatti': 'Contatti'
    },

    openOnGoogle: 'Apri su google maps',

    pageNotFound: {
      'title': 'Pagina non trovata',
      'content': 'La pagina che stai cercando non è presente in questo sito.'
    }

  }
}

export default messages
